import { NoResult } from '../utilities/no-result.js';
export class PromiseHelper {
    static timeout(timeout) {
        return new Promise((resolve, reject) => {
            try {
                setTimeout(() => {
                    resolve(NoResult.instance);
                }, timeout);
            }
            catch (e) {
                reject(e);
            }
        });
    }
}
//# sourceMappingURL=promise-helper.js.map